import { FinancialCharts } from '../../../_metronic/partials/widgets/charts/FinancialCharts'

const FinancialReport = () => {
  return (
    <>
    <FinancialCharts className='card-xl-stretch mb-xl-8' />
   </>
  )
}

export { FinancialReport }
